import { Stack } from "@mui/material";
import { ReactNode } from "react";
import { ResultsSwitch } from "../analytics/ShownResults.tsx";
import { GuideButton } from "./GuideButton.tsx";

/**
 * The header of a page, with at its end the switch of the results it shows,
 * where it shows a case's results, and the button of the page's guide.
 */
export const GuideHeader = ({ children }: { children: ReactNode }) => (
  <Stack
    direction="row"
    spacing={2}
    useFlexGap
    sx={{
      alignItems: "flex-end",
      justifyContent: "space-between",
      flexWrap: "wrap",
    }}
  >
    {children}
    <Stack
      direction="row"
      spacing={1.5}
      useFlexGap
      sx={{ alignItems: "center", flexWrap: "wrap" }}
    >
      <ResultsSwitch />
      <GuideButton />
    </Stack>
  </Stack>
);
